import CorporateActionsCalendarStore from './CorporateActionsCalendarStore';
import TailwindPaginationStore from '../Pagination/TailwindPaginationStore';

/**
 * コーポレートアクション株式分割ルートストア
 *
 * @module CorporateActions/CorporateActionsStockTransferStore
 */
const CorporateActionsStockTransferStore = {
  modules: {
    corporateActionsCalendar: CorporateActionsCalendarStore,
    tailwindPagination: TailwindPaginationStore,
  },
};
export default CorporateActionsStockTransferStore;
